import { styled } from '@mui/material/styles';
import { Box as MuiBox, Paper as MuiPaper, Typography, IconButton, Icon as MuiIcon } from '@mui/material';

const Box = styled(MuiBox)(({ theme }) => ({
    'height': '100%',
    'paddingRight': theme.spacing(2),
    'overflowY': 'scroll',
    '&::-webkit-scrollbar': {
      width: 4,
      marginLeft: -4,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.grey[200],
      borderRadius: 2,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.text.secondary,
      borderRadius: 2,
      outline: 'none',
    },
}));

const Paper = styled(MuiPaper)(({ theme }) => ({
    position: 'fixed',
    top: 60,
    bottom: 85,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 740,
    maxWidth: '100%',
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '12px 12px 0 0',
    [theme.breakpoints.down('sm')]: {
      bottom: 230,
    },
}));

const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
}));

const Icon = styled(MuiIcon)(({ theme }) => ({
}));

export { Box, Title, Paper, CloseButton, Icon };
